import { useState } from 'react'

import { BookablesScrollContainer } from './bookables-scroll-container'

const CLASS_NAME = 'bookable-selection-screen'

type ClaimCenterBookableContainerProps = {
  claimCenterName: string
  slots: Array<{ id: string; display: { localTime: string } }>
  selectedSlotId?: string
}

export const ClaimCenterBookableContainer = ({
  claimCenterName,
  slots,
  selectedSlotId,
}: ClaimCenterBookableContainerProps) => {
  const [showArrows, setShowArrows] = useState(false)
  const headingId = `claim-center-heading-${claimCenterName.replace(/\s+/g, '-').toLowerCase()}`

  if (slots?.length === 0) {
    return (
      <section aria-labelledby={headingId}>
        <div className={`${CLASS_NAME}__claim-center-header`}>
          <h4 id={headingId} className={`${CLASS_NAME}__claim-center-header__claim-center-name`}>
            {claimCenterName}
          </h4>
        </div>
        <p className={`${CLASS_NAME}__no-availability`} aria-live="polite">
          No appointments available on this day.
        </p>
      </section>
    )
  }

  return (
    <section aria-labelledby={headingId}>
      <div className={`${CLASS_NAME}__claim-center-header`}>
        <h4 id={headingId} className={`${CLASS_NAME}__claim-center-header__claim-center-name`}>
          {claimCenterName}
        </h4>
        {showArrows && (
          <div className={`${CLASS_NAME}__claim-center-header__swipe-for-availability`}>
            Swipe or tap the arrow for more availability
          </div>
        )}
      </div>
      <BookablesScrollContainer
        slots={slots}
        onArrowVisibilityChange={setShowArrows}
        selectedSlotId={selectedSlotId}
      />
    </section>
  )
}
